import React from "react";
import { Grid, Modal, Box, Typography, TextField, Checkbox, MenuItem } from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import Close from "@material-ui/icons/Close";
import styled from "styled-components";

const ScheduleSendModal = ({
  mailData,
  setMailData,
  timezones,
  bottomToolbarStates,
  setBottomToolbarStates,
}) => {
  return (
    <Modal
      open={bottomToolbarStates.isScheduleSendModal}
      onClose={() => setBottomToolbarStates({ ...bottomToolbarStates, isScheduleSendModal: false })}
    >
      <StyledBox>
        <StyledGrid container alignItems="center">
          <Grid item>
            <Typography>Set Schedule Send</Typography>
          </Grid>
          <Grid item style={{ flex: "1" }}></Grid>
          <Grid item>
            <Close
              onClick={() =>
                setBottomToolbarStates({ ...bottomToolbarStates, isScheduleSendModal: false })
              }
              style={{ color: "white" }}
            />
          </Grid>
        </StyledGrid>
        <Grid container alignItems="center" style={{ padding: "10px 15px" }} direction="column">
          <Grid container alignItems="center">
            <Grid item>
              <Typography color="textSecondary" variant="body1">
                Use Schedule Send
              </Typography>
            </Grid>
            <Grid item>
              <Checkbox
                style={{ marginLeft: "10px" }}
                onClick={() => {
                  setMailData({ ...mailData, check: !mailData.check });
                }}
                checked={mailData.check}
              />
            </Grid>
          </Grid>
          <Grid container alignItems="center" style={{ marginBottom: "10px" }}>
            <Grid item style={{ marginRight: "14px" }}>
              <Typography color="textSecondary" variant="body1">
                {`Select Time & Date`}
              </Typography>
            </Grid>
            <Grid item style={{ flex: "1" }}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DateTimePicker
                  ampm={false}
                  disablePast
                  fullWidth={true}
                  value={mailData.selectedDateAndTime}
                  onChange={(val) =>
                    setMailData({ ...mailData, selectedDateAndTime: Date.parse(val) })
                  }
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
          <Grid container alignItems="center">
            <Grid item style={{ marginRight: "24px" }}>
              <Typography color="textSecondary" variant="body1">
                Select Timezone
              </Typography>
            </Grid>

            <Grid item style={{ flex: "1" }}>
              <TextField
                select
                fullWidth={true}
                variant="outlined"
                value={mailData.selectedTimezone}
                onChange={(e) => {
                  setMailData({ ...mailData, selectedTimezone: e.target.value });
                }}
              >
                {timezones?.map((el) => (
                  <MenuItem key={el.value} value={el.value}>{el.name}</MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Grid>
      </StyledBox>
    </Modal>
  );
};

export default ScheduleSendModal;

const StyledBox = styled(Box)`
  && {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 50%;
    background-color: white;
    border-radius: 5px;
    box-shadow: 0.5px 1px 25px 0.5px rgba(0, 0, 0, 0.3);
  }
`;
const StyledGrid = styled(Grid)`
  && {
    padding: 10px 10px 10px 10px;
    background-color: #404040;
    color: white;
  }
`;